import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'

export default class Frontenddevelopertemplate extends Component {
  render() {
    const course = [
      {
        title: "Introduction to Web Development",
        content: [
        "Introduction to HTML",
        "Introduction to CSS",
        "Introduction to JavaScript",
        "Web development basics",
        "Web development tools and environment setup"
        ]
        },
        {
        title: "HTML and CSS Fundamentals",
        content: [
        "HTML tags and structure",
        "CSS selectors and properties",
        "CSS layout and positioning",
        "Responsive web design",
        "CSS frameworks and libraries"
        ]
        },
        {
        title: "JavaScript Fundamentals",
        content: [
        "JavaScript syntax and variables",
        "JavaScript operators and data types",
        "JavaScript functions and control flow",
        "DOM manipulation",
        "Event handling"
        ]
        },
        {
        title: "Advanced JavaScript",
        content: [
        "Advanced JavaScript concepts",
        "Object-oriented programming in JavaScript",
        "Error handling and debugging",
        "Asynchronous JavaScript and APIs",
        "JavaScript frameworks and libraries"
        ]
        },
        {
        title: "Web Accessibility and Usability",
        content: [
        "Introduction to web accessibility",
        "Creating accessible HTML and CSS",
        "Accessible JavaScript and forms",
        "Web usability principles",
        "User experience design"
        ]
        },
        {
        title: "Responsive Design and Development",
        content: [
        "Responsive web design principles",
        "Responsive CSS techniques",
        "Responsive images and video",
        "Mobile-first design and development",
        "Progressive web apps"
        ]
        },
        {
        title: "Web Performance Optimization",
        content: [
        "Introduction to web performance",
        "Optimizing images and video",
        "Minifying and compressing code",
        "Caching and CDNs",
        "Performance testing and measurement"
        ]
        },
        {
        title: "Version Control with Git",
        content: [
        "Introduction to version control",
        "Using Git for version control",
        "Branching and merging in Git",
        "Collaborating with Git",
        "Git best practices"
        ]
        },
        {
        title: "Building Web Applications",
        content: [
        "Web application architecture",
        "Server-side programming with Node.js",
        "Web APIs and RESTful web services",
        "Database integration and management",
        "Deployment and DevOps"
        ]
        },
        {
        title: "Testing and Debugging",
        content: [
        "Introduction to software testing",
        "Unit testing and integration testing",
        "End-to-end testing with Selenium",
        "Debugging tools and techniques",
        "Testing best practices"
        ]
        },
        {
        title: "Web Security",
        content: [
        "Introduction to web security",
        "Web security threats and vulnerabilities",
        "Authentication and authorization",
        "Secure coding practices",
        "Web security best practices"
        ]
        },
        {
        title: "Emerging Frontend Technologies",
        content: [
        "Introduction to emerging frontend technologies",
        "WebAssembly",
        "Web Components",
        "Machine learning in web development",
        "Virtual and augmented reality"
        ]
        }
    ]

    const faqData = [
      {
        question: 'What is Front End Development?',
        answer:
          'Front End Development refers to the practice of creating the visual elements of a website or web application that users interact with directly',
      },
      {
        question: 'What skills are required for Front End Development?',
        answer:
          'Skills required include proficiency in HTML, CSS, and JavaScript, familiarity with responsive design principles, knowledge of front end frameworks like React or Angular, and understanding of web accessibility standards',
      },
      {
        question: 'How can Front End Development training benefit my career?',
        answer:
          'Front End Development training provides you with in-demand skills sought after by employers, enhances your career prospects, and prepares you for roles like Front End Developer, Web Designer, or UI/UX Designer',
      },
      {
        question: `What career opportunities are available for someone with ${this.props.title} skills?`,
        answer:
          'Front-end developers can pursue a variety of career opportunities such as UI/UX designer, front-end developer, full-stack developer, web developer, and mobile developer.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Explore the Eligibility Requirements at our leading learning institute for aspiring Front End Developers. As the best training center in the industry, we offer comprehensive courses tailored to equip you with the skills and knowledge necessary to thrive in the dynamic field of front end development. Whether you're a beginner with a passion for coding or an experienced professional seeking to enhance your skill set, our expert instructors will guide you through hands-on training, real-world projects, and cutting-edge technologies. Join us and embark on your journey to becoming a proficient Front End Developer with confidence and expertise"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
    return (
      <>
       
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="A frontend developer, a specialized type of web developer, plays a crucial role in shaping the visual and interactive aspects of a website or web application. Their primary responsibility revolves around crafting the user interface (UI) and user experience (UX) components, ensuring that the site not only looks aesthetically pleasing but also functions seamlessly." /> */}
          <NewMainsec rating='4.9' students={"675"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="A frontend developer, a specialized type of web developer, plays a crucial role in shaping the visual and interactive aspects of a website or web application. Their primary responsibility revolves around crafting the user interface (UI) and user experience (UX) components, ensuring that the site not only looks aesthetically pleasing but also functions seamlessly." />

          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
            <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Looking for the best front-end-developer ${this.props.location1}? Look no further than Learnsoft.org! Our top-rated courses are designed to help you master the skills you need to succeed in this exciting field. With a focus on hands-on training and real-world scenarios, our experienced trainers will guide you through everything from HTML and CSS to JavaScript and jQuery.`}
              title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our comprehensive front-end-developer course covers everything you need to know to become a skilled and successful front-end developer. Topics covered include HTML, CSS, JavaScript, jQuery, Bootstrap, AngularJS, and more. Our trainers use a hands-on approach to help you gain practical experience and learn how to implement these technologies in real-world scenarios. By the end of the course, you'll be well-versed in front-end development and ready to take your career to the next level."} />
          </section>
          <Batchtime title={this.props.title} fees="25,999" offer="15,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
          <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Java" coupath7="java" cou6='Python' coupath6='python' cou4='Full Stack Developer' coupath4='full-stack-developer' cou='AngularJS' coupath='angularjs' cou3='ReactJS' coupath3='reactjs'
          cou10='R Programming' coupath10='rprogram' cou9='JavaScript' coupath9='javascript' cou1='VueJS' coupath1='vuejs'
          cou5='TypeScript' coupath5='type-script' cou2='Flutter' coupath2='flutter'  cou8='Go' coupath8='go' />

      </>
    );
  }
}
